import { ChackImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetServices =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.services.get;

      const response = await PostFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageServices =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      if (editMode) {
        bodyFormData.append("id", values?.id);
      }

      if (CheckDataIfExit(values?.title)) {
        bodyFormData.append("title", values?.title?.trim());
      } else {
        bodyFormData.append("title", "");
      }
      if (CheckDataIfExit(values?.bg_color)) {
        bodyFormData.append("bg_color", values?.bg_color?.trim());
      } else {
        bodyFormData.append("bg_color", "");
      }
      if (CheckDataIfExit(values?.text_color)) {
        bodyFormData.append("text_color", values?.text_color?.trim());
      } else {
        bodyFormData.append("text_color", "");
      }
      if (CheckDataIfExit(values?.description)) {
        bodyFormData.append("description", values?.description?.trim());
      } else {
        bodyFormData.append("description", "");
      }
      if (CheckDataIfExit(values?.type)) {
        bodyFormData.append("type", values?.type?.trim());
      } else {
        bodyFormData.append("type", "");
      }

      if (
        values?.icon &&
        values?.icon != null &&
        values?.icon != undefined &&
        ChackImageIsFile({ data: values?.icon, IsBoolean: true })
      ) {
        bodyFormData.append("icon", values?.icon);
      } else if (editMode && !values?.icon) {
        bodyFormData.append("icon", "");
      }

      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode ? UrlApi.services.edit : UrlApi.services.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditServices =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          id: id,
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.services.edit,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteServices =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data = {
        idsservices: id,
      };
      const response = await PostFunction({
        data,
        Route: UrlApi.services.delete,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
